import React from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/lego_penguin.jpeg";

function NavBar() {
  return (
    <header className="top-nav">
      <div className="container nav-inner">
        <NavLink to="/buy" className="brand">
          <img src={logo} alt="Lego penguin" />
          <span>My Lego Stock</span>
        </NavLink>
        <nav>
          <NavLink to="/buy">Buy</NavLink>
          <NavLink to="/sell">Sell</NavLink>
          <NavLink to="/stock">Stock</NavLink>
          <NavLink to="/mylego">New</NavLink>
        </nav>
      </div>
    </header>
  );
}

export default NavBar;
